import React, { FC, useEffect, useState } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { useLoginFinishMutation, useLoginMutation } from '../../services/auth.api';

import { Loader, BackButton, Button, CodeInput } from '../../shared/ui';
import { useLazyMeQuery } from '../../services/users.api';
import { setCredentials, setUserData } from '../../store/auth.slice';
import { useAppDispatch } from '../../hooks/redux';

import Timer from './timer';

interface IProps {
  onBackToAuth: () => void;
  email: string;
  confirmCodex?: boolean;
}

const ConfirmAuth: FC<IProps> = ({ confirmCodex = false, onBackToAuth, email }) => {
  const [authCode, setAuthCode] = useState<(string | null)[]>([null, null, null, null, null]);
  const [isErrorCode, setIsErrorCode] = useState(false);
  const [error, setError] = useState('');
  const [login] = useLoginMutation();
  const [loginFinish, { isLoading }] = useLoginFinishMutation();
  const [me] = useLazyMeQuery();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (authCode && authCode.filter((el) => el !== null && el !== '' && +el >= 0 && +el <= 9).length === 5) {
      onAuthFinish();
    }
    // eslint-disable-next-line
  }, [authCode]);

  const onCodeChange = (code: string[]) => {
    setIsErrorCode(false);
    setError('');
    setAuthCode(code);
  };

  const onAuthFinish = async () => {
    if (authCode.filter((el) => el !== null && el !== '' && +el >= 0 && +el <= 9).length !== 5) {
      setIsErrorCode(true);
      setError('Введите код');
      return;
    }

    try {
      const tokenData = await loginFinish({ email, authCode: authCode.join('') }).unwrap();
      dispatch(setCredentials(tokenData));
      const userData = await me().unwrap();
      dispatch(setUserData(userData));
      navigate('/consultations', { state: { previousLocationPathname: location.pathname } });
    } catch (e: any) {
      console.log(e);
      if (e.status === 422) {
        setIsErrorCode(true);
        setError(e.data.detail);
      }
    }
  };

  const onRefreshAuthCode = async () => {
    await login({ email }).unwrap();
  };
  return (
    <>
      {isLoading && <Loader />}
      <div className="w-full max-w-[420px] sm:max-w-[550px] max-h-[90%] overflow-y-auto rounded-popup bg-white p-[10px] md:p-[50px] short:p-[10px]">
        <div className="flex items-center text-center text-display-s md:text-display-l short:text-display-s mb-2.5">
          <BackButton className="-m-1.5" onClick={onBackToAuth} />

          <span className="grow text-center">Подтверждение</span>
        </div>
        <div className="text-center sm:px-[30px] text-ui md:text-body-l text-ink-muted mb-7 short:mb-5 md:mb-10">
          На почту {email} был отправлен код подтверждения, который необходимо ввести для того, чтобы войти в Личный
          кабинет.
        </div>
        <div className="mb-7 md:mb-10 short:mb-5">
          <div className="mb-7 short:mb-5">
            <CodeInput
              label="Код из письма"
              value={authCode.map((digit) => digit ?? '')}
              onChange={onCodeChange}
              invalid={isErrorCode}
            />
          </div>

          <Timer minutes={1} seconds={0} onRefreshAuthCode={onRefreshAuthCode} />
        </div>

        {error && <div className="text-primary mb-2.5">{error}</div>}

        <div className="mb-7 short:mb-5">
          <Button size="lg" fullWidth onClick={onAuthFinish}>
            Подтвердить
          </Button>
        </div>
      </div>
    </>
  );
};

export default ConfirmAuth;
